import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-todo-priority-menu', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    priority: {
      type: String,
      default: 'normal',
    },
    priorityLabel: {
      type: String,
      default: '普通',
      observer() {
        this.changePriorityLabel();
      },
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.menu = this.querySelector('tr-menu');

    this.listenTo(this.menu, {
      'tr-menu:selected': (e) => {
        this.priority = e.detail.item.dataset.value;
        this.priorityLabel = e.detail.item.dataset.label;
        this.update();
      },
    });
  },

  changePriorityLabel() {
    this.querySelector('.todo-priority-label').text = this.priorityLabel;
  },

  update() {
    let dataType = 'json';
    if (this.url.indexOf('members') !== -1) {
      dataType = 'script';
    }
    $.ajax({
      url: this.url,
      type: 'patch',
      dataType,
      data: {
        'todos_management[priority]': this.priority,
      },
      success: () => {
        if (!this.reload) return;
        window.tower.stack.load(window.location.href, {
          root: true,
          replace: true,
          nocache: true,
          fluid: true,
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
